import { jsx as _jsx } from "react/jsx-runtime";
import { logger } from '@lichtblick/logger';
import { useTracker } from '@lichtblick/tracker';
import { createContext, useContext, useEffect } from 'react';
export const createFailureEvent = (funnelState)=>({
        eventName: 'form_failed',
        customProps: {
            form_name: 'B2B Solar Request',
            error_message: funnelState.errors?.generic,
            request_type: funnelState.formValues.solarRequestType
        }
    });
export const createSuccessEvent = (funnelState)=>({
        eventName: 'form_submit_b2b_solar_request',
        customProps: {
            unique_id: funnelState.requestId,
            request_type: funnelState.formValues.solarRequestType
        }
    });
const virtPageTitleDictionary = {
    solarRequestType: undefined,
    address: 'Embedded B2B Solar Request Adresse',
    contactPerson: 'Embedded B2B Solar Request Kontaktperson',
    email: 'Embedded B2B Solar Request E-Mail'
};
export const PageMetaContext = /*#__PURE__*/ createContext({
    pageArea: 'EaaS',
    pageType: 'product'
});
export const PageMetaProvider = ({ children, value })=>/*#__PURE__*/ _jsx(PageMetaContext.Provider, {
        value: value,
        children: children
    });
export const useStepTracking = (funnelState)=>{
    const pageMetaClassification = useContext(PageMetaContext);
    const { trackPageMetaEvent, trackVirtPathEvent } = useTracker();
    // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
    useEffect(()=>{
        const virtPageTitle = virtPageTitleDictionary[funnelState.currentStep];
        logger.info(`EMBEDDED_SOLAR_FUNNEL: Entering Step ${funnelState.currentStep}`);
        if (virtPageTitle) {
            const virtPagePath = `/${virtPageTitle.replace(/\s/g, '-').toLowerCase()}/`;
            // Page and Virtual Path tracking
            trackVirtPathEvent({
                virtPagePath,
                virtPageTitle
            });
            trackPageMetaEvent(pageMetaClassification);
        }
    }, [
        funnelState.currentStep
    ]);
};

//# sourceMappingURL=b2b-funnel-embed.tracking.js.map